import React from "react";
import styled from "styled-components";

const Aggregate = (props) => {
  const Icon = styled.i`
    color: ${window.lrmSettings["primary"]};
  `;
  let starCount = "";
  if (props.avgRating > 4 && props.avgRating < 5) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star-half-alt"></Icon>
      </>
    );
  }
  if (props.avgRating === 5) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating === 4) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }

  if (props.avgRating >= 3 && props.avgRating < 4) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star-half-alt"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating === 3) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating > 2 && props.avgRating < 3) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star-half-alt"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating === 2) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating >= 1 && props.avgRating < 2) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="fas fa-star-half-alt"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating < 1) {
    starCount = (
      <>
        <Icon className="fas fa-star-half-alt"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating === 1) {
    starCount = (
      <>
        <Icon className="fas fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  if (props.avgRating === 0) {
    starCount = (
      <>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
        <Icon className="far fa-star"></Icon>
      </>
    );
  }
  return (
    <div className="lrm-reviews-aggregate">
      <h3>
        Average Rating:
        <br />
        {props.avgRating} Stars
        <br />
        {starCount}
      </h3>
      <h5>{props.reviewCount} total reviews</h5>
    </div>
  );
};

export default Aggregate;
